<script lang="ts" setup>
const route = useRoute()
const { data: page, pending, error: _error } = await useAsyncData(route.path, () => {
  return queryCollection('investigation').path(route.path).first()
})

// Handle 404 if page not found
if (!pending.value && !page.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Investigation not found',
  })
}

useHead(page.value?.head || {})
useSeoMeta(page.value?.seo || {})
</script>

<template>
  <ApplicationLoading v-if="pending" size="lg" text="Onderzoek laden..." />
  <section v-else-if="page" class="p-4">
    <UBreadcrumb
      v-if="page" :items="[
        {
          label: 'Onderzoek',
          to: '/onderzoek',
        },
        {
          label: page.title,
        },
      ]"
      class="hidden lg:block mb-4"
    />
    <VideoPreview :url="page.video" class="mb-6 overflow-auto rounded-lg border border-neutral-200 dark:border-neutral-600" />
    <div class="mx-auto max-w-screen-md">
      <InvestigationArticleDate v-if="page" :page="page" />
      <ContentRenderer v-if="page" :value="page" />
      <ApplicationArticleLocations :article="page" class="my-8" />
      <ApplicationArticleFirstChapterButton class="mt-8" />
    </div>
  </section>
</template>
